import { render, staticRenderFns } from "./IpList.vue?vue&type=template&id=eb2165a0&scoped=true"
import script from "./IpList.vue?vue&type=script&lang=js"
export * from "./IpList.vue?vue&type=script&lang=js"
import style0 from "./IpList.vue?vue&type=style&index=0&id=eb2165a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2165a0",
  null
  
)

export default component.exports